// Český slovník – zdroj pravdy pro tvar překladů. Ostatní jazyky se typují
// proti `Dict`, takže TypeScript ohlídá chybějící nebo přebývající klíč.
// Plochá tečková notace ⇒ jednoduchá typová kontrola klíčů a parita slovníků.
// Interpolace přes {placeholder} (viz useT).
export const cs = {
  // Horní lišta
  "topbar.locating": "Hledám…",
  "topbar.locate": "📍 Najít mě",
  "topbar.addCancel": "Zrušit",
  "topbar.add": "+ Přidat WC",

  // Filtry
  "filters.wheelchair": "♿ Bezbariérové",
  "filters.free": "🆓 Zdarma",
  "filters.changingTable": "🍼 Přebalovací pult",
  "filters.count": "{n} WC",
  "filters.countTruncated": "{n}+ WC · přibliž mapu",

  // Mapa
  "map.addHint": "Klikni do mapy na místo, kde je WC.",

  // Detail WC
  "detail.dialogLabel": "Detail WC",
  "detail.close": "Zavřít",
  "detail.defaultName": "Veřejné WC",
  "detail.paid": "💰 Placené",
  "detail.free": "🆓 Zdarma",
  "detail.wheelchair": "♿ Bezbariérové",
  "detail.changingTable": "🍼 Přebalovací pult",
  "detail.distance": "📏 {d} od tebe",
  "detail.navigate": "🧭 Navigovat",
  "detail.shared": "✓ Zkopírováno",
  "detail.share": "🔗 Sdílet",
  "detail.openPage": "📄 Stránka WC",

  // Formulář přidání WC
  "form.title": "Nové WC",
  "form.name": "Název (nepovinné)",
  "form.namePlaceholder": "např. WC u parku",
  "form.wheelchair": "Bezbariérové",
  "form.fee": "Placené",
  "form.changingTable": "Přebalovací pult",
  "form.openingHours": "Otevírací doba",
  "form.openingHoursPlaceholder": "Po–Pá 8–20",
  "form.note": "Poznámka",
  "form.cancel": "Zrušit",
  "form.saving": "Ukládám…",
  "form.save": "Uložit",
  "form.error": "Něco se pokazilo.",
  "form.missingSiteKey":
    "Přidávání WC je dočasně nedostupné – chybí konfigurace ochrany proti spamu.",

  // Sdílení
  "share.copyPrompt": "Zkopíruj odkaz:",

  // Street-level náhled
  "streetview.open": "🗺️ Otevřít okolí ve Street View",
  "streetview.expand": "Zobrazit interaktivní náhled okolí",

  // Geolokace
  "geo.userPos": "Tvoje poloha",
  "geo.unsupported": "Tvůj prohlížeč nepodporuje geolokaci.",
  "geo.failed": "Nepodařilo se zjistit polohu: {error}",

  // Země (`country.at` čeká na AT seed migraci – viz lib/countries.ts)
  "country.label": "Země",
  "country.cz": "Česko",
  "country.at": "Rakousko",
} as const;

/** Tvar slovníku – zdroj pro typování ostatních jazyků. */
export type Dict = Record<keyof typeof cs, string>;
